<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part" id="part-001"><span epub:type="pagebreak" id="page_3" title="3"><div class="part_debut"></div><h1 class="part_surtit" epub:type="title"><span><img alt="Illustration" class="imagelarge_intext" id="part1" src="images/part1.jpg"/></span></h1><h1 class="part_tit" epub:type="title"><span>L<span class="small">IVING</span> D<span class="small">EEP IN THE</span> K<span class="small">INGDOM</span></span></h1><h1 class="part_stit" epub:type="subtitle"><span><img alt="Illustration" class="imagelarge_intext" id="tiret" src="images/tiret.jpg"/><span epub:type="pagebreak" id="page_4" title="4"></span></span></h1></span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?b36b4b52